// extracted by mini-css-extract-plugin
module.exports = {"Highlights":"Highlights_Highlights__pf_3B","Modal":"Highlights_Modal__pd6T_","HideButtons":"Highlights_HideButtons__W4Bkm","Preview":"Highlights_Preview__E4Njh"};